
<template>
  <section id="deep">
    <div class="wrapper">
      <div class="content">
<!--        <div class="col col-1 ft-30">-->
<!--          {{$t('home.deep.title1')}}<br>-->
<!--          {{$t('home.deep.title2')}}<br>-->
<!--          {{$t('home.deep.title3')}}-->
<!--        </div>-->
        <div class="col col-2">
          <div class="logo-wrap">
            <img class="front"
              src="/images/logo-1-light.png" alt="">
            <img class="end"
              src="/images/logo-1.png" alt="">
          </div>

          <!-- <div class="logo-wrap">
            <img class="front"
              src="/images/logo-2-light.png" alt="">
            <img class="end"
              src="/images/logo-2.png" alt="">
          </div> -->

          <div class="logo-wrap">
            <img class="front"
              src="/images/logo-3-light.png" alt="">
            <img class="end"
              src="/images/logo-3.png" alt="">
          </div>

        </div>
        <div class="col col-3">
          <div class="row ft-14" v-html="$t('home.deep.content')"></div>
          <div class="ul-warp">
            <ul class="ft-14">
              <li class="row">{{$t('home.deep.ul[0]')}}</li>
<!--              <li class="row">{{$t('home.deep.ul[1]')}}</li>-->
              <li class="row">{{$t('home.deep.ul[2]')}}</li>
              <!-- <li class="row">{{$t('home.deep.ul[3]')}}</li> -->
            </ul>

            <!-- <div class="btn-know ft-16">深入了解</div> -->
            <Knowbtn1 @btnclick="gotoPage" />
          </div>
        </div>
      </div>

      <div ref="counts" class="counts content">
        <Counter ref="count1"
          url="/images/icon-users.png"
          :title="$t('home.deep.count[0]')"
          :num="1000">
          <div class="mark ft-14">+</div>
        </Counter>

        <Counter ref="count2"
          url="/images/icon-area.png"
          :title="$t('home.deep.count[1]')"
          :num="45000">
          <div class="mark ft-14">M</div>
          <div class="mark2 ft-10">2</div>
        </Counter>

        <Counter ref="count3"
          url="/images/icon-room.png"
          :title="$t('home.deep.count[2]')"
          :num="35000">
          <div class="mark ft-14">㎡</div>
        </Counter>

        <Counter ref="count4"
          url="/images/icon-fish.png"
          :title="$t('home.deep.count[3]')"
          :num="50000">
          <div class="mark ft-14">T</div>
        </Counter>
      </div>

      <div class="conter-info ft-12">{{$t('home.deep.count[4]')}}</div>
    </div>

    <div
      class="scene"
      data-bg
      data-tablet="/images/deep-tablet.jpg"
      data-mobile="/images/deep-mobile.jpg"
    ></div>
    <canvas class="displacement"></canvas>
  </section>
</template>

<script>
import Counter from '@/components/Counter.vue'
import Knowbtn1 from '@/components/Knowbtn1.vue'
import scroll from '@/oceanSchool/scroll.js'
import SceneDeep from '@/oceanSchool/sceneDeep.js'

export default {
  components: {
    Counter,
    Knowbtn1
  },

  beforeDestroy () {
    this.sceneDeep && this.sceneDeep.dispose()
    this.sceneDeep = null
  },

  mounted () {
    this.$nextTick(() => {
      scroll.bind('play-counter', this.scrollPlayCounter)
    })
  },

  methods: {
    start () {
      this.sceneDeep = new SceneDeep(this.$el)
    },

    scrollPlayCounter () {
      if (!this.$refs.counts) return

      const { bottom } = this.$refs.counts.getBoundingClientRect()
      if (bottom < window.innerHeight) {
        scroll.unbind('play-counter')
        this.$refs.count1.play()
        this.$refs.count2.play()
        this.$refs.count3.play()
        this.$refs.count4.play()
      }
    },
    gotoPage () {
      let routeUrl = this.$router.resolve('/about')
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  color: #fff;
}

#deep {
  padding: 0 150px;
  background: #05111f
}

#deep .play {
  border: 2px solid #fff;
  border-radius: 100%;
  box-shadow: 0 1px 1px rgba(0,0,0,.15);
  color: #fff;
  left: 50%;
  padding: 25px;
  position: absolute;
  top: 50%;
  transform: translate3d(-50%,-50%,0);
  will-change: opacity;
  z-index: 1020;
}

#deep .play:before {
  content: '';
  display: block;
  position: absolute;
  top: 15px;
  left: 22px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #fff
}

#deep .play:hover {
  background-color: #fff
}

#deep .wrapper {
  height: 100%;
  text-align: center
}

#deep .wrapper a {
  display: block
}

#deep .wrapper a.cta {
  margin-top: 40px;
  display: inline-block;
  background-color: #ef4325;
  border: none;
  padding: 20px 40px
}

#deep .wrapper a.cta span {
  transition: color .25s ease .09s
}

#deep .wrapper a.cta:hover span {
  color: #0b1539
}

#deep video {
  width: 100%
}

@media (max-width: 1024px) {
  #deep {
      padding:280px 0;
      .scene{
        background-image: url(/images/deep-tablet.jpg);
      }
  }
}

@media (max-width: 768px) {
  #deep {
      padding:150px 0
  }
}

@media (max-width: 640px) {
  #deep .scene{
    background-image: url(/images/deep-mobile.jpg);
  }
}

@media (max-width: 480px) {
  #deep {
      padding: 120px 0;
  }
}

.content {
  display: flex;
  justify-content: space-between;

  .row {
    color: #83949b;
    line-height: 36px;
  }

  .col-1, .col-2 {
    line-height: 60px;
    max-width: 260px;
  }
  .col-2 {
    margin-top: 90px;

    .logo-wrap {
      cursor: pointer;
      position: relative;
      width: 170px;
      height: 60px;
      margin-bottom: 40px;

      img {
        position: absolute;
      }

      img.front {
        opacity: 1;
        transition: opacity 0.8s ease-in-out;
      }
      img.end {
        opacity: 0;
        transition: opacity 0.8s ease-in-out;
      }
    }

    .logo-wrap:hover img.front {
      opacity: 0;
    }
    .logo-wrap:hover img.end {
      opacity: 1;
    }
  }
  .col-3 {
    margin-top: 160px;
    max-width: 800px;
    text-align: left;

    .ul-warp {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      ul {
        margin-left: 40px;
        list-style: disc inside;
      }
    }
  }

  .mark, .mark2 {
    color: #83949b;
  }
}

@media (max-width: 768px) {
  .content .col-1,
  .content .col-2{
    display: none
  }
  .content .col-3{
    margin-top: 0;
  }
  .content .col-3 .ul-warp{
    flex-direction: column;
    align-items: initial;
    .btn-know{
      margin-top: 20px;
      align-self: center;
    }
  }
}

.counts {
  margin-top: 100px;
}

.conter-info {
  margin: 50px 0;
  color: #83949b;
  text-align: right;
}
@media(max-width: 1366px){
  .counts{
    margin-top: 48px;
  }
}
@media(max-width: 768px){
  .content{
    flex-direction: column;
    .count{
      justify-content: center
    }
    .count+.count{
      margin-top: 20px;
    }
  }
}

// #deep .subtitle {
//   font-size: 3.15vw;
//   margin: 0 auto;
//   color: #cde3e8
// }

// @media (min-width: 1441px) {
//   #deep .subtitle {
//       width:85%
//   }
// }

// @media (min-width: 1681px) {
//   #deep .subtitle {
//       width:100%
//   }
// }

// @media (min-width: 1921px) {
//   #deep .subtitle {
//       font-size:2.8vw
//   }
// }

// @media (max-width: 768px) {
//   #deep .subtitle {
//       font-size:5.9vw;
//       line-height: 1.35
//   }
// }

// #deep .subtitle+p {
//   margin: 35px 0 0;
//   color: #cde3e8
// }

#deep .scene {
  z-index: 1050;
  display: none
}

@media (max-width: 1024px) {
  #deep .scene {
      display:block
  }
}

.mobile #deep .scene,.tablet #deep .scene {
  display: block
}

#deep .scene__item {
  width: 100%;
  height: 100%;
  z-index: 1010;
  backface-visibility: hidden;
  position: absolute;
  pointer-events: none
}

#deep .scene__item img {
  position: absolute;
  width: auto
}

#deep .scene__item--medusa:nth-child(1) img {
  top: 15%;
  left: -230px;
  transform: rotate(-10deg) scale(.85);
  filter: blur(1px);
  opacity: .6;
  outline: 1px solid #ff0
}

#deep .scene__item--medusa:nth-child(2) img {
  top: 50%;
  left: 12%;
  transform: rotate(-20deg);
  display: none;
  outline: 1px solid green
}

#deep .scene__item--medusa:nth-child(3) img {
  top: 18%;
  left: 23%;
  transform: rotate(-5deg);
  display: none
}

#deep .scene__item--medusa:nth-child(4) img {
  top: 15%;
  left: 55%;
  outline: 1px solid red
}

#deep .scene__item--medusa:nth-child(5) img {
  top: 40%;
  left: auto;
  right: -120px;
  transform: rotate(-15deg);
  outline: 1px solid red
}

#deep .scene__item--medusa:nth-child(6) img {
  top: 77%;
  left: auto;
  right: 40px;
  transform: rotate(-40deg);
  outline: 1px solid red
}

#deep .scene__item--medusa:nth-child(7) img {
  top: 85%;
  left: 5px;
  transform: rotate(5deg);
  outline: 1px solid red
}
@media screen and (max-width:1366px){
  .content .col-1{
    width: 200px;
  }
  .content .ft-30{
    font-size: 20px;
  }
  .content .col-3{
    padding-left: 30px;
  }
}
</style>
